(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3028,346],{

/***/ 38875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconMore = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 21,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M10.561 16c-.242 0-.477-.084-.665-.24l-6.233-5.043a.681.681 0 0 1-.094-.925.635.635 0 0 1 .894-.125l6.098 4.936 9.166-7.671a.635.635 0 0 1 .912.097.68.68 0 0 1-.096.938l-9.299 7.78a1.052 1.052 0 0 1-.683.253Zm-8.06-6.414a.646.646 0 0 1-.402-.142L.289 7.972a.682.682 0 0 1-.15-.968.635.635 0 0 1 .949-.078l1.815 1.468c.28.23.329.65.109.94a.653.653 0 0 1-.51.252Zm8.29-.369c-.243 0-.477-.084-.667-.24L3.875 3.943a.68.68 0 0 1-.095-.925.635.635 0 0 1 .895-.125l6.115 4.928L19.943.149a.637.637 0 0 1 .912.097.681.681 0 0 1-.095.94l-9.3 7.778c-.19.16-.425.25-.67.253ZM2.716 2.804a.659.659 0 0 1-.402-.142L.505 1.19a.68.68 0 0 1-.07-.903.636.636 0 0 1 .87-.142L3.12 1.612h-.001c.28.23.329.648.108.938a.658.658 0 0 1-.51.254Z",
  fill: "currentcolor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconMore);

/***/ }),

/***/ 93940:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate",
      function () {
        return __webpack_require__(11402);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81057);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34495);
/* harmony import */ var _elements_LazyImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20027);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41197);
/* harmony import */ var _helpers_getS3Url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27895);






var StaffVertical = function(param) {
    var picture = param.picture, cloudflare_picture = param.cloudflare_picture, first_name = param.first_name, last_name = param.last_name, job = param.job, email = param.email, description = param.description, sizes = param.sizes, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_4__/* .withModifiers */ .i)("staff", variant, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default())),
        children: [
            picture && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().staff__image),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_LazyImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    alt: "Profile image-".concat(picture),
                    layout: "fill",
                    sizes: sizes,
                    src: cloudflare_picture ? (0,_helpers_getS3Url__WEBPACK_IMPORTED_MODULE_3__/* .getS3Url */ .v)(cloudflare_picture, "960") : (0,_helpers_getS3Url__WEBPACK_IMPORTED_MODULE_3__/* .getS3Url */ .v)(picture)
                })
            }, picture),
            (first_name || last_name) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().staff__name),
                children: "".concat(first_name, " ").concat(last_name)
            }),
            job && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().staff__occupation),
                children: job
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().staff__description),
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
                rel: "nofollow",
                href: "mailto:".concat(email),
                variant: [
                    "label",
                    "font-primary"
                ],
                children: [
                    "Email ",
                    first_name
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StaffVertical);


/***/ }),

/***/ 26189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74218);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73985);
/* harmony import */ var _Accordion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42192);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var AccordionGroup = function(param) {
    var items = param.items, _max = param.max, max = _max === void 0 ? 9999 : _max;
    if (items) {
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), openKey = ref[0], setOpenKey = ref[1];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().faqs),
            children: items.map(function(faq, index) {
                return index < max && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_transition_group__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    classNames: "opacity",
                    appear: true,
                    timeout: {
                        enter: index * 150,
                        exit: index * 150
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Accordion__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        index: index,
                        openKey: openKey,
                        setOpenKey: setOpenKey,
                        variant: [
                            "large"
                        ],
                        title: faq.question,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: faq.answer
                            }
                        })
                    })
                }, index);
            })
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionGroup);


/***/ }),

/***/ 96143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42998);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34495);




var LineSeparator = function(param) {
    var _width = param.width, width = _width === void 0 ? false : _width, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: width ? {
            width: width
        } : {},
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__/* .withModifiers */ .i)("separator", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(variant), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LineSeparator);


/***/ }),

/***/ 90346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _layout_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70539);
/* harmony import */ var _layout_Columns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40050);
/* harmony import */ var _custom_Highlight__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(958);
/* harmony import */ var _custom_Staff__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33528);
/* harmony import */ var _components_ContactForm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64150);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61137);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40670);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34495);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79697);
/* harmony import */ var _elements_Grid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(117);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);


















var Contact = function(param) {
    var title = param.title, description = param.description, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, _buying = param.buying, buying = _buying === void 0 ? true : _buying, _separator = param.separator, separator = _separator === void 0 ? true : _separator, staff = param.staff, _leftLabel = param.leftLabel, leftLabel = _leftLabel === void 0 ? true : _leftLabel, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, sectionRef = param.sectionRef, route = param.route, translations = param.translations;
    var ref = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_8__/* .useResponsive */ .F)(), isTablet = ref.isTablet, isSmallMobile = ref.isSmallMobile;
    var isGeneral = variant.includes("general");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false), loaded = ref1[0], setLoaded = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        return setLoaded(true);
    }, []);
    if (loaded) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            sectionRef: sectionRef,
            separator: separator,
            variant: [
                variant.includes("gray") ? "gray" : "white"
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Columns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: [
                        isTablet ? "-align-center" : "-distribute-between"
                    ],
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            spans: isSmallMobile ? 12 : isTablet ? 7 : 6,
                            children: [
                                leftLabel && staff && !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(staff) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_14__/* .withModifiers */ .i)("intro", [
                                        isGeneral && "general",
                                        !leftLabel && "offset-top"
                                    ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default())),
                                    children: leftLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            " ",
                                            translations.interestedIn[router.locale],
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Highlight__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                variant: [
                                                    "accent",
                                                    "font-primary"
                                                ],
                                                children: translations.buying[router.locale]
                                            }),
                                            " ",
                                            translations.property[router.locale]
                                        ]
                                    }) : ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    children: staff && !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(staff) && staff.map(function(person, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Staff__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                                            width: isSmallMobile && 168,
                                            height: isSmallMobile && 308,
                                            variant: [
                                                "inline",
                                                "align-middle"
                                            ]
                                        }, person), {
                                            job: person.job[router.locale]
                                        }), "contact-staff-".concat(index));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            spans: isSmallMobile ? 12 : isTablet ? 11 : 6,
                            children: [
                                description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().description),
                                    children: description
                                }),
                                isGeneral || title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title),
                                    children: title || translations.assistance[router.locale]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_9___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().intro), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().last)),
                                    children: [
                                        translations.interestedIn[router.locale],
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Highlight__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            variant: [
                                                "font-primary",
                                                buying && "accent"
                                            ],
                                            children: buying ? translations.buying[router.locale] : translations.renting[router.locale]
                                        }),
                                        translations.thisProperty[router.locale]
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContactForm__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    route: route,
                                    translations: translations,
                                    disabled: disabled
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["default"] = (Contact);


/***/ }),

/***/ 7633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19511);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41197);
/* harmony import */ var _public_icons_icon_more_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38875);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _elements_AccordionGroup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26189);








var FAQs = function(param) {
    var label = param.label, title = param.title, faqs = param.faqs, button = param.button;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(5), number = ref[0], setNumber = ref[1];
    if (faqs) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            variant: [
                "gray",
                "center"
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                variant: [
                    "-xs3"
                ],
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().label),
                        children: label
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_AccordionGroup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        items: faqs,
                        max: number
                    }),
                    number < faqs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        appendIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_icons_icon_more_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                        variant: [
                            "color-primary"
                        ],
                        arrow: false,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().button),
                        onClick: function() {
                            return setNumber(number + 5);
                        },
                        children: button
                    })
                ]
            })
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQs);


/***/ }),

/***/ 30124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _elements_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(117);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36779);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _custom_StaffVertical__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35193);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40670);








var Professionals = function(param) {
    var label = param.label, title = param.title, staff = param.staff;
    var ref = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__/* .useResponsive */ .F)(), isDesktop = ref.isDesktop, isSmallMobile = ref.isSmallMobile;
    if (staff && title) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            separator: true,
            variant: [
                "center",
                "separator-top"
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                variant: [
                    isDesktop ? "-xs2" : "-xl2"
                ],
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                        children: label
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                        children: title
                    }),
                    staff && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Grid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            variant: [
                                isSmallMobile ? "grid-1" : isDesktop ? "grid-2" : "grid-4",
                                "spacing-xl"
                            ],
                            children: staff.map(function(item, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_StaffVertical__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                    sizes: "(min-width: 1250px) 310px, (max-width: 1250px) 300vw, 70vw"
                                }, item), "staff-".concat(index));
                            })
                        })
                    })
                ]
            })
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["Z"] = (Professionals);


/***/ }),

/***/ 61312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _layout_Columns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40050);
/* harmony import */ var _layout_Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70539);
/* harmony import */ var _elements_LazyImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20027);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6879);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40670);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34495);
/* harmony import */ var lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79697);
/* harmony import */ var _helpers_getS3Url__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27895);
/* harmony import */ var _single_property_components_Perk__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);













var Promo = function(param) {
    var _content = param.content, content = _content === void 0 ? false : _content;
    var ref = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_6__/* .useResponsive */ .F)(), isDesktop = ref.isDesktop, isSmallMobile = ref.isSmallMobile;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), loaded = ref1[0], setLoaded = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        setLoaded(true);
    }, []);
    if (!content) {
        return;
    }
    if (content && !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(content) && loaded) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            variant: [
                "gray"
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                children: content.map(function(column, index) {
                    var isFirstColumn = index === 0;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Columns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        variant: [
                            isFirstColumn ? "-distribute-between" : "-align-end",
                            !isDesktop && "-align-middle"
                        ],
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().columns),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                spans: isFirstColumn ? isSmallMobile ? 12 : 5 : isSmallMobile ? 12 : isDesktop ? 6 : 7,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_12__/* .withModifiers */ .i)("image", [
                                        !isFirstColumn && "second"
                                    ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default())),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_LazyImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        src: (0,_helpers_getS3Url__WEBPACK_IMPORTED_MODULE_7__/* .getS3Url */ .v)(column.cloudflare_picture),
                                        layout: "fill",
                                        objectFit: "cover",
                                        objectPosition: "center"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().column),
                                spans: isFirstColumn ? isSmallMobile ? 12 : isDesktop ? 7 : 6 : isSmallMobile ? 12 : isDesktop ? 5 : 4,
                                children: column.content ? column.content.map(function(item, index) {
                                    switch(item.type){
                                        case "Title":
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().title),
                                                children: item.data.title
                                            }, "title-".concat(index));
                                        case "Description":
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: item.data.description
                                                }
                                            }, "description-".concat(index));
                                        case "Statistics":
                                            return item.data.map(function(perk, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_single_property_components_Perk__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    icon: perk.cloudflare_icon,
                                                    title: perk.title,
                                                    value: perk.value
                                                }, "column-perk-".concat(index));
                                            });
                                    }
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().title),
                                            children: column.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            angerouslySetInnerHTML: {
                                                __html: column.description
                                            }
                                        })
                                    ]
                                })
                            })
                        ]
                    }, "promo-column-".concat(index));
                })
            })
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["Z"] = (Promo);


/***/ }),

/***/ 50597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _elements_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(117);
/* harmony import */ var _custom_EstateCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78032);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69950);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41197);
/* harmony import */ var _public_icons_icon_more_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38875);
/* harmony import */ var _elements_LineSeparator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96143);
/* harmony import */ var _elements_Card__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55877);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66261);












var Overview = function(param) {
    var properties = param.properties, _type = param.type, type = _type === void 0 ? "real-estate" : _type, shadowRef = param.shadowRef, scrollRef = param.scrollRef, _totalCards = param.totalCards, totalCards = _totalCards === void 0 ? 999 : _totalCards, generalTranslation = param.generalTranslation, _buttonLabel = param.buttonLabel, buttonLabel = _buttonLabel === void 0 ? "View more real estate" : _buttonLabel, _unlimited = param.unlimited, unlimited = _unlimited === void 0 ? false : _unlimited, title = param.title;
    var scroll = react_scroll__WEBPACK_IMPORTED_MODULE_9__["default"].animateScroll;
    var handleScroll = function() {
        var ref;
        return scrollRef && scroll.scrollTo(((ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().top) - document.body.getBoundingClientRect().top - 150);
    };
    if (properties) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            variant: [
                "white",
                "pt0",
                "center"
            ],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: shadowRef,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().overlay)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    variant: [
                        "-xxl"
                    ],
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Grid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().grid),
                            variant: [
                                "grid-".concat(totalCards)
                            ],
                            children: properties.map(function(item, index) {
                                if (index < totalCards || unlimited) {
                                    if (type === "real-estate") {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_EstateCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                            translations: generalTranslation
                                        }, item), index);
                                    } else {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Card__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                            translations: generalTranslation
                                        }, item), index);
                                    }
                                }
                            })
                        }),
                        buttonLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_LineSeparator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            variant: [
                                "vertical"
                            ]
                        }),
                        buttonLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_5__["default"], {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().button),
                            appendIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_icons_icon_more_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                            onClick: handleScroll,
                            variant: [
                                "color-primary"
                            ],
                            children: buttonLabel
                        })
                    ]
                })
            ]
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["Z"] = (Overview);


/***/ }),

/***/ 1962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30959);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34495);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_getS3Url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27895);





var Perk = function(param) {
    var icon = param.icon, title = param.title, value = param.value, children = param.children, subtitle = param.subtitle, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_3__/* .withModifiers */ .i)("perk", variant, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())),
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().perk__icon),
                children: icon && typeof icon === "object" ? icon : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    width: 38,
                    height: 38,
                    alt: "icon ".concat(title),
                    src: (0,_helpers_getS3Url__WEBPACK_IMPORTED_MODULE_2__/* .getS3Url */ .v)(icon)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().perk__title),
                        children: value
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: subtitle
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: title
                        },
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().perk__description)
                    }),
                    children && children
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Perk);


/***/ }),

/***/ 11402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ real_estate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/templates/Page/index.js + 16 modules
var Page = __webpack_require__(51904);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./components/pages/real-estate/Welcome/styles.module.scss
var styles_module = __webpack_require__(40668);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/elements/DateSearch/index.js + 10 modules
var DateSearch = __webpack_require__(85137);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./components/configs/axios.js
var axios = __webpack_require__(92375);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/pages/real-estate/Welcome/index.js










var Welcome = function(param) {
    var totalProperties = param.totalProperties, translations = param.translations, shadowRef = param.shadowRef, contentTranslations = param.contentTranslations;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isActive = ref[0], setIsActive = ref[1];
    var ref1 = (0,react.useState)(false), maxPrice = ref1[0], setMaxPrice = ref1[1];
    (0,react.useEffect)(function() {
        axios/* default.get */.Z.get("real-estate/properties/max-price").then(function(res) {
            setMaxPrice(res.data / 1000);
        });
    }, [
        router.locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
        variant: [
            "center"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).intro,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (styles_module_default()).intro__title,
                        children: contentTranslations.title[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).intro__subtitle,
                        children: contentTranslations.description[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).intro__wrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,withModifiers/* withModifiers */.i)("intro__card", [
                                isActive && "is-active"
                            ], (styles_module_default())),
                            children: maxPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSearch/* default */.Z, {
                                translations: translations,
                                setIsActive: setIsActive,
                                isActive: isActive,
                                shadowRef: shadowRef,
                                optional: true,
                                price: maxPrice,
                                target: "real-estate",
                                form: [
                                    "location",
                                    "homeType",
                                    "priceRange",
                                    "bedrooms",
                                    "listings"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        href: "/real-estate/search",
                        variant: [
                            "label"
                        ],
                        children: "".concat(contentTranslations.see[router.locale], " ").concat(totalProperties, " ").concat(contentTranslations.properties[router.locale])
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var real_estate_Welcome = (Welcome);

// EXTERNAL MODULE: ./components/pages/real-estate/Overview/index.js
var Overview = __webpack_require__(50597);
// EXTERNAL MODULE: ./components/pages/common/Promo/index.js
var Promo = __webpack_require__(61312);
// EXTERNAL MODULE: ./components/pages/common/Professionals/index.js
var Professionals = __webpack_require__(30124);
// EXTERNAL MODULE: ./components/pages/common/FAQs/index.js
var FAQs = __webpack_require__(7633);
// EXTERNAL MODULE: ./components/pages/common/Contact/index.js
var Contact = __webpack_require__(90346);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./components/elements/Grid/index.js
var Grid = __webpack_require__(117);
// EXTERNAL MODULE: ./components/custom/EstateCard/index.js
var EstateCard = __webpack_require__(78032);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/elements/LineSeparator/index.js
var LineSeparator = __webpack_require__(96143);
;// CONCATENATED MODULE: ./components/pages/real-estate/Properties/index.js










var Properties = function(param) {
    var properties = param.properties, generalTranslation = param.generalTranslation, scrollRef = param.scrollRef, translations = param.translations;
    var ref = (0,ResponsiveContext/* useResponsive */.F)(), isTablet = ref.isTablet, isSmallMobile = ref.isSmallMobile;
    var router = (0,next_router.useRouter)();
    var totalCards = isTablet ? 6 : 9;
    var gridSetup = isSmallMobile ? 1 : isTablet ? 2 : 3;
    if (properties) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
            variant: [
                "gray",
                "center"
            ],
            sectionRef: scrollRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container["default"], {
                variant: [
                    "-xxl"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: translations.title[router.locale]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        variant: [
                            "grid-".concat(gridSetup)
                        ],
                        children: properties.map(function(item, index) {
                            if (index < totalCards) return /*#__PURE__*/ (0,jsx_runtime.jsx)(EstateCard/* default */.Z, (0,_object_spread/* default */.Z)({
                                translations: generalTranslation
                            }, item), index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LineSeparator/* default */.Z, {
                        variant: [
                            "vertical"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        dangerouslySetInnerHTML: {
                            __html: translations.subtitle[router.locale]
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        href: "/real-estate/search",
                        variant: [
                            "color-primary"
                        ],
                        children: "".concat(translations.all[router.locale], " ").concat(properties.length, " ").concat(translations.properties[router.locale])
                    })
                ]
            })
        });
    }
    return;
};
/* harmony default export */ var real_estate_Properties = (Properties);

// EXTERNAL MODULE: ./components/pages/real-estate/Features/styles.module.scss
var Features_styles_module = __webpack_require__(39919);
var Features_styles_module_default = /*#__PURE__*/__webpack_require__.n(Features_styles_module);
// EXTERNAL MODULE: ./components/layout/Columns/index.js
var Columns = __webpack_require__(40050);
// EXTERNAL MODULE: ./components/layout/Column/index.js
var Column = __webpack_require__(70539);
;// CONCATENATED MODULE: ./public/icons/icon-estate-feature-1.svg
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconEstateFeature1 = props => /*#__PURE__*/react.createElement("svg", _extends({
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M47.4 46.8H35.742v-4.152h6.15c.33 0 .6-.27.6-.6V.6c0-.33-.27-.6-.6-.6H6.108c-.33 0-.6.27-.6.6v41.448c0 .33.27.6.6.6h6.15V46.8H.6c-.33 0-.6.27-.6.6 0 .33.27.6.6.6h46.8c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6ZM6.708 1.2h34.59v40.248H6.708V1.2Zm6.75 41.448h21.084V46.8H13.458v-4.152Z",
  fill: "#999"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "m29.305 28.404-.246-4.632 2.928-3.606a.619.619 0 0 0 .108-.564.617.617 0 0 0-.42-.396l-4.5-1.2-2.538-3.894c-.222-.342-.78-.342-1.008 0l-2.538 3.894-4.5 1.2a.617.617 0 0 0-.42.396.584.584 0 0 0 .108.564l2.934 3.606-.246 4.632a.6.6 0 0 0 .816.588l4.35-1.662 4.35 1.662a.622.622 0 0 0 .57-.072.6.6 0 0 0 .246-.516h.006Zm-1.32-5.214a.597.597 0 0 0-.132.408l.21 3.942-3.702-1.416a.658.658 0 0 0-.216-.042.533.533 0 0 0-.216.042l-3.702 1.416.21-3.942a.618.618 0 0 0-.132-.408l-2.496-3.066 3.828-1.02a.572.572 0 0 0 .348-.252l2.16-3.312 2.16 3.312a.572.572 0 0 0 .348.252l3.828 1.02-2.49 3.066h-.006ZM18.904 32.347a.6.6 0 0 0-.828.174l-2.088 3.198a.6.6 0 0 0 .503.924.6.6 0 0 0 .505-.27l2.088-3.198a.594.594 0 0 0-.174-.828h-.006ZM24.116 32.898c-.33 0-.6.27-.6.6v3.69c0 .33.27.6.6.6.33 0 .6-.27.6-.6v-3.69c0-.33-.27-.6-.6-.6ZM30.177 32.576a.6.6 0 0 0-1.002.654l2.088 3.198a.6.6 0 0 0 .504.27.6.6 0 0 0 .504-.924l-2.088-3.198h-.006ZM32.091 6.097a.6.6 0 0 0-.828.174l-2.088 3.198a.6.6 0 0 0 .504.924.6.6 0 0 0 .504-.27l2.088-3.198a.594.594 0 0 0-.174-.828h-.006ZM24.14 9.75c.33 0 .6-.27.6-.6V5.46c0-.33-.27-.6-.6-.6-.33 0-.6.27-.6.6v3.69c0 .33.27.6.6.6ZM18.077 10.074a.6.6 0 0 0 .504.27.6.6 0 0 0 .504-.924l-2.088-3.198a.6.6 0 0 0-1.002.654l2.088 3.198h-.006Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_estate_feature_1 = (SvgIconEstateFeature1);
;// CONCATENATED MODULE: ./public/icons/icon-estate-feature-2.svg
var icon_estate_feature_2_path, icon_estate_feature_2_path2, _path3;

function icon_estate_feature_2_extends() { icon_estate_feature_2_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_estate_feature_2_extends.apply(this, arguments); }



const SvgIconEstateFeature2 = props => /*#__PURE__*/react.createElement("svg", icon_estate_feature_2_extends({
  viewBox: "0 0 55 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_estate_feature_2_path || (icon_estate_feature_2_path = /*#__PURE__*/react.createElement("path", {
  d: "M3.393 27.553a2.567 2.567 0 0 0 2.564-2.57c0-1.419-1.148-2.569-2.564-2.569a2.567 2.567 0 0 0-2.565 2.57 2.567 2.567 0 0 0 2.565 2.569ZM51.268 27.553a2.567 2.567 0 0 0 2.564-2.57c0-1.419-1.148-2.569-2.564-2.569a2.567 2.567 0 0 0-2.565 2.57 2.567 2.567 0 0 0 2.565 2.569ZM46.988 6.14v5.14H41.86M7.664 43.824v-5.139h5.13",
  stroke: "#999",
  strokeLinejoin: "round"
})), icon_estate_feature_2_path2 || (icon_estate_feature_2_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M51.14 27.434c-1.223 12.093-11.421 21.531-23.816 21.531-8.13 0-15.319-4.068-19.644-10.277M3.531 22.42C4.805 10.378 14.977 1 27.33 1c8.13 0 15.319 4.068 19.644 10.278",
  stroke: "#999",
  strokeMiterlimit: 10
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M38.865 20.04c-1.172-4.033-4.027-5.07-6.207-5.223a8.535 8.535 0 0 0-5.334 1.421c-1.727-1.456-3.94-2.192-6.146-2.038-2.18.163-5.035 1.199-6.206 5.224-.607 2.099-.23 4.428 1.017 6.218.436.625.992 1.148 1.599 1.602a2.309 2.309 0 0 0 .282 2.69 2.293 2.293 0 0 0 1.692.744c.06 0 .129-.008.188-.017.06.454.24.89.573 1.25.42.454 1 .72 1.616.737-.026.591.162 1.19.59 1.653a2.3 2.3 0 0 0 1.641.745c.051.463.24.908.573 1.276a2.32 2.32 0 0 0 1.658.745h.026c.624 0 1.222-.256 1.633-.693l1.521-1.49c.222-.232.393-.506.496-.806a2.13 2.13 0 0 0 1.24.394 2.183 2.183 0 0 0 2.154-2.518 1.925 1.925 0 0 0 1.18-.556c.375-.369.58-.883.59-1.448 0-.154-.026-.3-.052-.454a2.27 2.27 0 0 0 1.487-.633 2.275 2.275 0 0 0 .641-1.979c.18-.205.377-.411.53-.642a7.362 7.362 0 0 0 1.01-6.218l.008.017Zm-19.987 8.977a.922.922 0 0 1 0-1.242l1.266-1.225a.936.936 0 0 1 1.273-.06c.3.257.385.66.248 1.02l-1.29 1.267-.018.017a2.603 2.603 0 0 0-.273.351.923.923 0 0 1-1.197-.128h-.009Zm2.454.728 1.265-1.25a.915.915 0 0 0 .162-.155l.086-.077a.927.927 0 0 1 1.274-.06.87.87 0 0 1 .316.651.92.92 0 0 1-.24.668l-1.521 1.49a.935.935 0 0 1-.675.283.9.9 0 0 1-.667-.3.933.933 0 0 1 0-1.25Zm2.205 2.39 1.505-1.482a.927.927 0 0 1 1.274-.06.9.9 0 0 1 .316.65.886.886 0 0 1-.24.66l-1.521 1.49a.852.852 0 0 1-.675.283.9.9 0 0 1-.667-.3.933.933 0 0 1 0-1.25l.008.008Zm5.07 1.79-1.522 1.49c-.18.188-.453.274-.675.282a.9.9 0 0 1-.667-.3.926.926 0 0 1-.222-.762c.12-.085.23-.171.324-.274l1.522-1.49a2.48 2.48 0 0 0 .333-.454.917.917 0 0 1 .83.188h.008c.188.18.3.403.308.66a.886.886 0 0 1-.24.66Zm8.112-8.445c-.026.042-.068.077-.103.12l-4.522-4.763h-.008s0-.008-.009-.017l-2.137-2.064a.691.691 0 0 0-.957 0l-2.838 2.827a2.025 2.025 0 0 1-2.283.42.448.448 0 0 1-.265-.352.463.463 0 0 1 .145-.42l.821-.762a.697.697 0 0 0 .043-.968.694.694 0 0 0-.966-.043l-.82.763a1.827 1.827 0 0 0-.565 1.644 1.847 1.847 0 0 0 1.06 1.38c.453.196.923.299 1.393.299.881 0 1.753-.343 2.411-1.002l2.36-2.356 1.65 1.594 4.607 4.847a.9.9 0 0 1-.017 1.26.876.876 0 0 1-1.24 0l-2.846-2.947s-.06-.034-.086-.06l-1.949-2.047a.686.686 0 0 0-.966-.026.689.689 0 0 0-.025.968l4.616 4.865c.401.42.632.89.624 1.293a.677.677 0 0 1-.18.48c-.17.171-.316.197-.41.18-.18 0-.581-.112-1.188-.771l-4.617-4.865a.685.685 0 0 0-.965-.026.689.689 0 0 0-.026.968l2.36 2.484 3.06 3.34a.82.82 0 0 1-.043 1.148.802.802 0 0 1-1.12-.017l-1.29-1.276h-.01l-.025-.026a2.224 2.224 0 0 0-1.445-.54 2.25 2.25 0 0 0-2.197-2.03c0-.068.017-.137.009-.214a2.267 2.267 0 0 0-.787-1.627 2.296 2.296 0 0 0-1.983-.505 2.289 2.289 0 0 0-.726-1.2c-.924-.804-2.308-.736-3.129.13l-.667.65c-.538-.385-1.017-.822-1.393-1.362a6.037 6.037 0 0 1-.83-5.061c.77-2.63 2.445-4.06 4.993-4.248 2.009-.146 4.018.599 5.522 2.038.24.231.616.257.89.051 1.418-1.079 3.154-1.601 4.863-1.481 2.548.188 4.232 1.618 4.992 4.248a6.012 6.012 0 0 1-.829 5.061l.043.018Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_estate_feature_2 = (SvgIconEstateFeature2);
;// CONCATENATED MODULE: ./public/icons/icon-estate-feature-3.svg
var icon_estate_feature_3_path, icon_estate_feature_3_path2, icon_estate_feature_3_path3, _path4, _path5, _path6;

function icon_estate_feature_3_extends() { icon_estate_feature_3_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_estate_feature_3_extends.apply(this, arguments); }



const SvgIconEstateFeature3 = props => /*#__PURE__*/react.createElement("svg", icon_estate_feature_3_extends({
  viewBox: "0 0 60 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_estate_feature_3_path || (icon_estate_feature_3_path = /*#__PURE__*/react.createElement("path", {
  d: "M1 30c0-2.76 2.24-5 5-5s5 2.24 5 5M30 23v5",
  stroke: "#999",
  strokeLinejoin: "round"
})), icon_estate_feature_3_path2 || (icon_estate_feature_3_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M1 30C1 13.98 13.98 1 30 1s29 12.98 29 29",
  stroke: "#999",
  strokeLinejoin: "round"
})), icon_estate_feature_3_path3 || (icon_estate_feature_3_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M11 30c0-16.02 8-29 19-29s19 12.98 19 29",
  stroke: "#999",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  d: "M23 30c0-16.02 2-29 7-29s7 12.98 7 29M11 30c0-3.31 2.69-6 6-6s6 2.69 6 6M37 30c0-3.31 2.69-6 6-6s6 2.69 6 6M49 30c0-2.76 2.24-5 5-5s5 2.24 5 5",
  stroke: "#999",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
  d: "M23 30c0-3.87 3.13-7 7-7s7 3.13 7 7",
  stroke: "#999",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
  d: "M26 45c0 2.21 1.79 4 4 4s4-1.79 4-4-4-4-4-4-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4",
  stroke: "#B18D3B",
  strokeWidth: 1.6,
  strokeLinejoin: "round"
})));

/* harmony default export */ var icon_estate_feature_3 = (SvgIconEstateFeature3);
;// CONCATENATED MODULE: ./public/icons/icon-estate-feature-4.svg
var icon_estate_feature_4_path, icon_estate_feature_4_path2, icon_estate_feature_4_path3, icon_estate_feature_4_path4, icon_estate_feature_4_path5;

function icon_estate_feature_4_extends() { icon_estate_feature_4_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_estate_feature_4_extends.apply(this, arguments); }



const SvgIconEstateFeature4 = props => /*#__PURE__*/react.createElement("svg", icon_estate_feature_4_extends({
  viewBox: "0 0 46 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_estate_feature_4_path || (icon_estate_feature_4_path = /*#__PURE__*/react.createElement("path", {
  d: "M25.36 3.322C36.406 4.476 45.001 13.812 45.001 25c0 7.362-3.732 13.873-9.428 17.79M20.643 46.677C9.596 45.524 1 36.187 1 25c0-7.37 3.732-13.874 9.429-17.791M22.998 5.645c1.302 0 2.357-1.04 2.357-2.322C25.355 2.04 24.3 1 22.998 1c-1.302 0-2.357 1.04-2.357 2.323 0 1.282 1.055 2.322 2.357 2.322Z",
  stroke: "#999",
  strokeMiterlimit: 10
})), icon_estate_feature_4_path2 || (icon_estate_feature_4_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M22.998 49c1.302 0 2.357-1.04 2.357-2.322 0-1.283-1.055-2.322-2.357-2.322-1.302 0-2.357 1.04-2.357 2.322 0 1.283 1.055 2.323 2.357 2.323Z",
  stroke: "#999",
  strokeMiterlimit: 10
})), icon_estate_feature_4_path3 || (icon_estate_feature_4_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M8.086 18.032c2.648-5.489 8.329-9.29 14.913-9.29s12.265 3.801 14.913 9.29M37.912 31.969c-2.648 5.489-8.329 9.29-14.913 9.29s-12.265-3.794-14.913-9.29M8.852 25h28.285",
  stroke: "#B18D3B",
  strokeMiterlimit: 10
})), icon_estate_feature_4_path4 || (icon_estate_feature_4_path4 = /*#__PURE__*/react.createElement("path", {
  d: "M34.782 13.496c-2.734 1.82-6.992 2.989-11.785 2.989s-9.052-1.17-11.786-2.989M11.211 36.504c2.734-1.82 6.993-2.988 11.786-2.988 4.793 0 9.051 1.169 11.785 2.988M6.498 27.323c1.302 0 2.357-1.04 2.357-2.323 0-1.282-1.055-2.322-2.357-2.322-1.302 0-2.357 1.04-2.357 2.322 0 1.283 1.055 2.323 2.357 2.323ZM39.498 27.323c1.302 0 2.357-1.04 2.357-2.323 0-1.282-1.055-2.322-2.357-2.322-1.302 0-2.357 1.04-2.357 2.322 0 1.283 1.055 2.323 2.357 2.323Z",
  stroke: "#B18D3B",
  strokeMiterlimit: 10
})), icon_estate_feature_4_path5 || (icon_estate_feature_4_path5 = /*#__PURE__*/react.createElement("path", {
  d: "M23 41.258c3.038 0 5.5-7.279 5.5-16.258S26.038 8.742 23 8.742 17.5 16.022 17.5 25c0 8.98 2.462 16.258 5.5 16.258Z",
  stroke: "#B18D3B",
  strokeMiterlimit: 10
})));

/* harmony default export */ var icon_estate_feature_4 = (SvgIconEstateFeature4);
;// CONCATENATED MODULE: ./public/icons/icon-estate-feature-5.svg
var icon_estate_feature_5_path, icon_estate_feature_5_path2, icon_estate_feature_5_path3;

function icon_estate_feature_5_extends() { icon_estate_feature_5_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_estate_feature_5_extends.apply(this, arguments); }



const SvgIconEstateFeature5 = props => /*#__PURE__*/react.createElement("svg", icon_estate_feature_5_extends({
  viewBox: "0 0 71 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_estate_feature_5_path || (icon_estate_feature_5_path = /*#__PURE__*/react.createElement("path", {
  d: "M57.954 45.728 5.383 28.273M5.383 21.728l52.57-17.455M1 21.729c0-1.2.986-2.182 2.19-2.182 1.205 0 2.19.982 2.19 2.182v6.545c0 1.2-.985 2.182-2.19 2.182A2.193 2.193 0 0 1 1 28.274V21.73Z",
  stroke: "#999",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), icon_estate_feature_5_path2 || (icon_estate_feature_5_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M64.525 32.637v13.09A3.275 3.275 0 0 1 61.239 49a3.275 3.275 0 0 1-3.286-3.272V32.637M57.953 17.364V4.273A3.275 3.275 0 0 1 61.24 1a3.275 3.275 0 0 1 3.286 3.273v13.09M28.38 35.908v5.454l-15.333-5.454v-5.455M38.234 10.818v28.364",
  stroke: "#999",
  strokeLinejoin: "round"
})), icon_estate_feature_5_path3 || (icon_estate_feature_5_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M48.102 22.819c2.628 0 1.752-2.182 4.38-2.182 2.629 0 1.753 2.181 4.381 2.181 2.629 0 1.753-2.181 4.381-2.181 2.629 0 1.753 2.181 4.381 2.181 2.629 0 1.753-2.181 4.381-2.181M43.719 27.184c2.628 0 1.752 2.181 4.38 2.181 2.63 0 1.753-2.181 4.382-2.181 2.628 0 1.752 2.181 4.38 2.181 2.63 0 1.753-2.181 4.381-2.181 2.629 0 1.753 2.181 4.381 2.181",
  stroke: "#B18D3B",
  strokeLinejoin: "round"
})));

/* harmony default export */ var icon_estate_feature_5 = (SvgIconEstateFeature5);
;// CONCATENATED MODULE: ./components/pages/real-estate/Features/data.js






var data = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_estate_feature_1, {}),
        title: "Unrivaled marketing",
        description: "When you list you want your property to rise to the top. We can make that happen."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_estate_feature_2, {}),
        title: "Exclusive partnerships",
        description: "We’re able to amplify your listing through our strategic and exclusive partnerships. That means more eyes on your property."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_estate_feature_3, {}),
        title: "Brand reputation",
        description: "Sotheby’s International Realty opens doors for your listing that’s unmatched by other agencies"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_estate_feature_4, {}),
        title: "True global reach",
        description: "Your listing will be accessible throughout the world and shown in its best light."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_estate_feature_5, {}),
        title: "PR powerhouse",
        description: "Offal freegan drinking vinegar jianbing wolf glossier +1 disrupt. DSA shaman jean shorts raw denim."
    }
];
/* harmony default export */ var Features_data = (data);

;// CONCATENATED MODULE: ./components/pages/real-estate/Features/index.js









var Features = function(param) {
    var translations = param.translations;
    var ref = (0,ResponsiveContext/* useResponsive */.F)(), isMobile = ref.isMobile, isSmallMobile = ref.isSmallMobile;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
        variant: [
            "white",
            "center"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container["default"], {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Features_styles_module_default()).subtitle,
                    children: translations.label[router.locale]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    dangerouslySetInnerHTML: {
                        __html: translations.title[router.locale]
                    },
                    className: (Features_styles_module_default()).title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* default */.Z, {
                    className: (Features_styles_module_default()).columns,
                    variant: [
                        "-align-center"
                    ],
                    children: Features_data.map(function(feature, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                            spans: isSmallMobile ? 12 : isMobile ? 6 : 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Features_styles_module_default()).feature,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Features_styles_module_default()).feature__icon,
                                        children: feature.icon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (Features_styles_module_default()).feature__title,
                                        children: translations.features[index].title[router.locale]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: translations.features[index].description[router.locale]
                                    })
                                ]
                            })
                        }, "feature-".concat(index));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var real_estate_Features = (Features);

;// CONCATENATED MODULE: ./pages/real-estate/index.js













var RealEstate = function(param) {
    var contactTranslation = param.contactTranslation, headerTranslation = param.headerTranslation, footerTranslation = param.footerTranslation, generalTranslation = param.generalTranslation, pageTranslation = param.pageTranslation, pageData = param.pageData, properties = param.properties, exclusive = param.exclusive;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var shadowRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var scrollRef = (0,react.useRef)();
    var ref16 = (0,ResponsiveContext/* useResponsive */.F)(), isTablet = ref16.isTablet, isSmallMobile = ref16.isSmallMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page["default"], {
        meta: {
            title: pageTranslation === null || pageTranslation === void 0 ? void 0 : (ref = pageTranslation.seo) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1[router.locale],
            description: pageTranslation === null || pageTranslation === void 0 ? void 0 : (ref2 = pageTranslation.seo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.description) === null || ref3 === void 0 ? void 0 : ref3[router.locale]
        },
        headerTranslation: headerTranslation,
        footerTranslation: footerTranslation,
        footer: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(real_estate_Welcome, {
                translations: headerTranslation,
                totalProperties: (properties === null || properties === void 0 ? void 0 : properties.length) || 0,
                shadowRef: shadowRef,
                contentTranslations: pageTranslation === null || pageTranslation === void 0 ? void 0 : pageTranslation.welcome
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview/* default */.Z, {
                properties: properties || [],
                shadowRef: shadowRef,
                scrollRef: scrollRef,
                totalCards: isSmallMobile ? 1 : isTablet ? 2 : 3,
                buttonLabel: pageTranslation === null || pageTranslation === void 0 ? void 0 : (ref4 = pageTranslation.overview) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.button) === null || ref5 === void 0 ? void 0 : ref5[router.locale],
                generalTranslation: generalTranslation
            }),
            (pageData === null || pageData === void 0 ? void 0 : pageData.promo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo/* default */.Z, {
                content: pageData.promo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(real_estate_Features, {
                translations: pageTranslation === null || pageTranslation === void 0 ? void 0 : pageTranslation.features
            }),
            exclusive && /*#__PURE__*/ (0,jsx_runtime.jsx)(real_estate_Properties, {
                translations: pageTranslation === null || pageTranslation === void 0 ? void 0 : pageTranslation.properties,
                generalTranslation: generalTranslation,
                scrollRef: scrollRef,
                properties: exclusive
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Professionals/* default */.Z, {
                title: pageTranslation === null || pageTranslation === void 0 ? void 0 : (ref6 = pageTranslation.professionals) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.title) === null || ref7 === void 0 ? void 0 : ref7[router.locale],
                label: pageTranslation === null || pageTranslation === void 0 ? void 0 : (ref8 = pageTranslation.professionals) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.label) === null || ref9 === void 0 ? void 0 : ref9[router.locale],
                pageData: pageData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs/* default */.Z, {
                title: pageTranslation === null || pageTranslation === void 0 ? void 0 : (ref10 = pageTranslation.faqs) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.title) === null || ref11 === void 0 ? void 0 : ref11[router.locale],
                label: pageTranslation === null || pageTranslation === void 0 ? void 0 : (ref12 = pageTranslation.faqs) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.label) === null || ref13 === void 0 ? void 0 : ref13[router.locale],
                pageData: pageData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact["default"], {
                title: pageTranslation === null || pageTranslation === void 0 ? void 0 : (ref14 = pageTranslation.contact) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.title) === null || ref15 === void 0 ? void 0 : ref15[router.locale],
                separator: false,
                staff: pageData === null || pageData === void 0 ? void 0 : pageData.person,
                variant: [
                    "white"
                ],
                translations: contactTranslation
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var real_estate = (RealEstate);


/***/ }),

/***/ 81057:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"staff":"styles_staff__9uWL9","staff__image":"styles_staff__image__omVdv","staff__name":"styles_staff__name__rtWOB","staff__occupation":"styles_staff__occupation__FsJEM","staff__description":"styles_staff__description__FZpfS"};

/***/ }),

/***/ 74218:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faqs":"styles_faqs__LuqUI"};

/***/ }),

/***/ 42998:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__LP5R2","separator--vertical":"styles_separator--vertical__XAMVo","separator--center":"styles_separator--center__qDfXg","separator--full-width":"styles_separator--full-width__WOn53"};

/***/ }),

/***/ 61137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__R0Yt_","intro":"styles_intro__e1Is4","contact":"styles_contact___xZ2x","last":"styles_last__LjZl_","intro--general":"styles_intro--general__85IDi","intro--offset-top":"styles_intro--offset-top__l7dZT","title":"styles_title__HCVSt","description":"styles_description__T7k67","staff":"styles_staff__gQuG0","name":"styles_name__nWG3U","position":"styles_position__RkAOQ","label":"styles_label___1bq_","button":"styles_button__nXKqX","position--general":"styles_position--general__OycEg"};

/***/ }),

/***/ 19511:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__yafgT","title":"styles_title__fUnLg","button":"styles_button__qbQt6"};

/***/ }),

/***/ 36779:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__NZY4O","title":"styles_title__JcQ8_","content":"styles_content__P_r8Y"};

/***/ }),

/***/ 6879:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__t_7vA","columns":"styles_columns__fxEQB","column":"styles_column__pY9c7","image":"styles_image__ri71p","image--second":"styles_image--second__Yepmt"};

/***/ }),

/***/ 39919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__k9AiG","title":"styles_title__ZSjDP","columns":"styles_columns__udFeo","feature":"styles_feature__G8lDY","feature__icon":"styles_feature__icon__wfxP6","feature__title":"styles_feature__title__doYzB"};

/***/ }),

/***/ 69950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__BdQPF","button":"styles_button__XgHPz","overlay":"styles_overlay__AGHfS"};

/***/ }),

/***/ 40668:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro":"styles_intro__S9BUF","intro__title":"styles_intro__title__HUNBP","intro__subtitle":"styles_intro__subtitle__M6pcO","intro__wrapper":"styles_intro__wrapper__LCa_G","intro__card":"styles_intro__card__RjKdq","intro__card--is-active":"styles_intro__card--is-active__dWm__"};

/***/ }),

/***/ 30959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"perk":"styles_perk__aYDiO","perk__icon":"styles_perk__icon__9_PGC","perk__title":"styles_perk__title__wwvP5","perk--spacing-xs":"styles_perk--spacing-xs__knH3y","perk--accent":"styles_perk--accent__GH2LI","perk__description":"styles_perk__description__uG0rQ","perk--title-color-dark":"styles_perk--title-color-dark__eY0DF","perk--style-inverted":"styles_perk--style-inverted__MCh15","perk--large":"styles_perk--large__OH1me"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3790,2756,5675,7549,6820,8433,5798,3808,9584,8094,3817,5585,5444,7713,2133,9774,945,2888,179], function() { return __webpack_exec__(93940); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);